<template>
  <div class="body-width">
    <div class="div-row div-pad-top news-Medium-24">
      智能装载计算机系统-SmartLoad
    </div>
    <div class="div-row">
      <p class="indentation">
        SmartLoad是基于船舶三维设计模型计算的新一代智能化装载计算机系统。该系统支持散货、液货、集装箱等多种船型，用户界面友好、功能强大、计算精确、可信度高，以表格、二维及三维图形方式将计算结果展现给使用人员。该成果通过CCS、DNV
        GL、劳氏船级社认证，已授权国家发明专利5项，软件著作权9项，推广应用船舶达70余条。</p>
    </div>
    <div>
      <div class="div_right_float">
        <div class="function_detail" align="left">
        <span class="news-Medium-18">
          产品特点
        </span>
          <ul>
             <li><span>满足船级社对船舶装载计算机的所有功能要求</span></li>
             <li><span>基于船舶3D设计数据进行计算，计算精度高</span></li>
             <li><span>具有自主知识产权的浮态及强度计算</span></li>
             <li><span>船舶、舱室货物及油水的3D可视化</span></li>
             <li><span>基于纵倾优化的最佳配载</span></li>
          </ul>
          <div class="function_img">
            <img src="../../../../assets/images/productcenter/zncy/zz/1.png">
          </div>
          <div class="function_img">
            <img src="../../../../assets/images/productcenter/zncy/zz/2.png">
          </div>
        </div>
      </div>
      <div class="div_left_float pd_right">
        <div class="function_detail" align="left">
        <span class="news-Medium-18">
          基本功能
        </span>
          <ul>
             <li><span>浮态计算及校核 </span></li>
             <li><span>稳性计算及校核 </span></li>
             <li><span>纵向强度计算及校核 </span></li>
             <li><span>空档高度计算 </span></li>
             <li><span>螺旋桨浸深计算 </span></li>
             <li><span>IMO及巴拿马驾驶台视线计算 </span></li>
             <li><span>液位遥测系统 </span></li>
             <li><span>工况报告生成 </span></li>
             <li><span>装/卸货顺序 </span></li>
             <li><span>2D/3D可视化 </span></li>
             <li><span>六面水尺检量 </span></li>
             <li><span>横摇周期计算 </span></li>
             <li><span>载重线校核 </span></li>
             <li><span>自动声光报警提示 </span></li>
             <li><span>吃水差调整功能 </span></li>
             <li><span>多种度量单位转换 </span></li>
          </ul>
          <div class="function_img">
            <img src="../../../../assets/images/productcenter/zncy/zz/3.png">
          </div>
        </div>
      </div>
    </div>
    <div class="pd_top">
      <div class="div_right_float">
        <div class="function_detail" align="left">
        <span class="news-Medium-18">
          散货船
        </span>
          <ul>
             <li><span>IACS UR S17单舱破损校核</span></li>
             <li><span>谷物稳性校核</span></li>
             <li><span>货舱载重极限校核</span></li>
             <li><span>隔舱装载CSR剪力修正</span></li>
             <li><span>甲板货、钢卷、木材装载</span></li>
             <li><span>谷物装载及校核</span></li>
             <li><span>生成美国/加拿大/澳大利亚散粮报告</span></li>
          </ul>
          <div class="function_img">
            <img src="../../../../assets/images/productcenter/zncy/zz/4.png">
          </div>
        </div>
      </div>
      <div class="div_left_float">
        <div class="function_detail" align="left">
        <span class="news-Medium-18">
          液货船
        </span>
          <ul>
             <li><span>UR L5（type 3）直接破舱稳性计算 </span></li>
             <li><span>ASTM 石油计量表 </span></li>
             <li><span>实测舱容表 </span></li>
             <li><span>石油密度转换 </span></li>
             <li><span>Ullage/OBQ/ROB报告 </span></li>
             <li><span>危险货物隔离检测 </span></li>
          </ul>
          <div class="function_img img_top">
            <img src="../../../../assets/images/productcenter/zncy/zz/5.png">
          </div>
        </div>
      </div>
    </div>
    <div class="div_right_float" style="padding-top: 40px">
      <div class="function_detail" align="left">
      <span class="news-Medium-18">
        集装箱船
      </span>
        <ul>
           <li><span>2D/3D操作及显示</span></li>
           <li><span>订舱订单导入及导出</span></li>
           <li><span>IMDG危险货物装载</span></li>
           <li><span>冷藏箱装载及设定</span></li>
           <li><span>进出口EDI(1.5/2.2/3.1)文件</span></li>
           <li><span>绑扎计算</span></li>
           <li><span>Irregular stowage check</span></li>
           <li><span>自动报告（普通/危险/冷藏箱）</span></li>
        </ul>
        <div class="function_img">
          <img src="../../../../assets/images/productcenter/zncy/zz/6.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "znzzjsjxt"
  }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .function_img {
    padding-left: 25px;
    padding-top: 20px;
  }

  .div_right_float {
    float: left;
  }

  .div_left_float {
    float: right;
  }

  .pd_top {
    padding-top: 737px;
  }

  .pd_right {
    padding-right: 210px
  }

  .img_top {
    padding-top: 45px;
  }
  p{
    font-size: 16px;
  }
  li{
    color: #2E79BE;
  }
  li span{
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/zncyxlcp/znzzjsjxt.vue